function addToCartAndOpenDrawer(event, variantId) {
  event.preventDefault();
  
  const data = {
    items: [{
      id: variantId,
      quantity: 1
    }]
  };

  // Show loading state
  const button = event.target.closest('button');
  if (button) button.classList.add('loading');

  function updateCartDrawer(response) {
    // Get cart drawer element
    const cartDrawer = document.querySelector('cart-drawer');
    
    // Fetch updated cart drawer content
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        // Get the drawer inner content
        const drawerInner = cartDrawer.querySelector('.drawer__inner');
        const sourceInner = html.querySelector('.drawer__inner');
        
        if (drawerInner && sourceInner) {
          // Update the entire drawer inner content
          drawerInner.innerHTML = sourceInner.innerHTML;
        }

        // Update cart state
        cartDrawer.classList.remove('is-empty');
        
        // Remove empty content if it exists
        const emptyContent = cartDrawer.querySelector('.drawer__inner-empty');
        if (emptyContent) emptyContent.remove();

        // Open the drawer
        cartDrawer.open();

        // Dispatch events in sequence
        document.documentElement.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              product: response,
              source: 'product-form'
            }
          })
        );

        // Use requestAnimationFrame to ensure DOM updates complete
        requestAnimationFrame(() => {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                source: 'product-form'
              }
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { source: 'product-form' }
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart-drawer-items:updated', {
              bubbles: true
            })
          );
        });
      });
  }

  // First add the item to cart
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(response => {
    // Apply quantity-based promotional rules
    return applyPromotionalRules().then(() => {
      return updateCartDrawer(response);
    }).catch((error) => {
      console.error('Error applying promotional rules:', error);
      // Continue with normal cart drawer update even if promo fails
      return updateCartDrawer(response);
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    // Remove loading state
    if (button) button.classList.remove('loading');
  });
}

async function applyPromotionalRules() {
try {
  // Get current cart contents
  const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();
  
  // Define promotional products
  const MAIN_PRODUCT = '46480730095883';
  const PROMO_PRODUCT_1 = '52443362361611'; // For 2-5 units
  const PROMO_PRODUCT_2 = '52443356233995'; // For 6+ units
  
  // Count main product quantity
  let mainProductQty = 0;
  let promoProduct1Qty = 0;
  let promoProduct2Qty = 0;
  
  cart.items.forEach(item => {
    if (item.variant_id.toString() === MAIN_PRODUCT) {
      mainProductQty += item.quantity;
    } else if (item.variant_id.toString() === PROMO_PRODUCT_1) {
      promoProduct1Qty += item.quantity;
    } else if (item.variant_id.toString() === PROMO_PRODUCT_2) {
      promoProduct2Qty += item.quantity;
    }
  });
  
  // Calculate required promo products based on rules
  let requiredPromo1 = 0;
  let requiredPromo2 = 0;
  
  if (mainProductQty >= 2 && mainProductQty <= 3) {
    requiredPromo1 = 1;
  } else if (mainProductQty >= 4 && mainProductQty <= 5) {
    requiredPromo1 = 3;
  } else if (mainProductQty >= 6) {
    requiredPromo2 = 1;
  }
  
  // Adjust promo product quantities
  const updates = [];
  
  // Handle promo product 1 (52443362361611)
  if (requiredPromo1 !== promoProduct1Qty) {
    if (requiredPromo1 === 0 && promoProduct1Qty > 0) {
      // Remove all promo product 1
      updates.push(updateCartItem(PROMO_PRODUCT_1, 0));
    } else if (requiredPromo1 > promoProduct1Qty) {
      // Add the difference
      const difference = requiredPromo1 - promoProduct1Qty;
      updates.push(addCartItem(PROMO_PRODUCT_1, difference));
    } else if (requiredPromo1 < promoProduct1Qty) {
      // Remove excess by setting to exact required amount
      updates.push(setCartItemQuantity(PROMO_PRODUCT_1, requiredPromo1));
    }
  }
  
  // Handle promo product 2 (52443356233995)
  if (requiredPromo2 !== promoProduct2Qty) {
    if (requiredPromo2 === 0 && promoProduct2Qty > 0) {
      // Remove all promo product 2
      updates.push(updateCartItem(PROMO_PRODUCT_2, 0));
    } else if (requiredPromo2 > promoProduct2Qty) {
      // Add the difference
      const difference = requiredPromo2 - promoProduct2Qty;
      updates.push(addCartItem(PROMO_PRODUCT_2, difference));
    } else if (requiredPromo2 < promoProduct2Qty) {
      // Remove excess by setting to exact required amount
      updates.push(setCartItemQuantity(PROMO_PRODUCT_2, requiredPromo2));
    }
  }
  
  // Execute all updates sequentially to avoid conflicts
  for (const update of updates) {
    await update;
  }
  
} catch (error) {
  console.error('Error in promotional rules:', error);
  throw error;
}
}

async function updateCartItem(variantId, quantity) {
try {
  // Set exact quantity using cart update (mainly for setting to 0)
  const updates = {};
  updates[variantId] = quantity;
  
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ updates })
  });
} catch (error) {
  console.error('Error updating cart item:', error);
  throw error;
}
}

async function addCartItem(variantId, quantity) {
try {
  // Add specific quantity to cart
  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  });
} catch (error) {
  console.error('Error adding cart item:', error);
  throw error;
}
}

async function setCartItemQuantity(variantId, quantity) {
try {
  // Set exact quantity using cart update
  const updates = {};
  updates[variantId] = quantity;
  
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ updates })
  });
} catch (error) {
  console.error('Error setting cart item quantity:', error);
  throw error;
}
}